import getUserSettingsAction from 'owa-calendar-configuration/lib/services/getUserSettingsAction';
import store from '../store/store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { TXP_OPTIONS_V2_FEATURE, TxpSettingsDataPointNames } from '../helpers/TxpConstants';
import TxpSettingsEntryPoint from '../store/schema/TxpSettingsEntryPoint';
import { logCalendarUsage } from 'owa-shared-analytics';
import { trace } from 'owa-trace';

/**
 * Returns the TXP settings which is observable
 */
export default async function sendTxpUserSettingsAction(
    shouldLogDatapoint?: boolean,
    entryPoint?: TxpSettingsEntryPoint
) {
    if (isFeatureEnabled(TXP_OPTIONS_V2_FEATURE)) {
        try {
            const response = await getUserSettingsAction(shouldLogDatapoint, entryPoint);
            store.txpSettings = await response.json();
        } catch (e) {
            trace.error(e.message);
            logCalendarUsage(TxpSettingsDataPointNames.TXPSettingsResponseError);
        }
    }
}
